// src/client.js
import { createThirdwebClient, getContract } from "thirdweb";
import { baseSepolia } from "thirdweb/chains";
export const client = createThirdwebClient({
  clientId: "c2b9732dcfae609e8f953fddcd1f42ce", // Replace with your actual ID
});
export const contract = getContract({
  client,
  chain: baseSepolia, // Match your deployment network
  address: "0x6C0cF778B4B964cb51381D0735A747A913945ED6",
});